import { atom } from 'recoil'
import { Status } from 'enums'
import { History } from 'types'

export const statusState = atom<Status>({
  key: 'statusState',
  default: Status.NOT_YET,
})

export const questionIndexState = atom<number>({
  key: 'questionIndexState',
  default: 0,
})

export const resultIndexState = atom<number>({
  key: 'resultIndexState',
  default: 0,
})

export const answerHistoryState = atom<History>({
  key: 'answerHistoryState',
  default: [],
})
